import marketingLeads from './marketing-leads'
import aiCustomerAcquisition from './ai-customer-acquisition'

export default {
  marketingLeads,
  aiCustomerAcquisition
}
